;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import CarouselProvider from 'components/ui/CarouselProvider';

import Deck from './Deck';

const FlipDeck = ({
    slides,
    flushTop = false,
    flushBottom = false,
    isLight = false,
    isCreamHeavy = false,
}) => {
    return (
        <CarouselProvider slides={slides}>
            <Deck
                flushTop={flushTop}
                flushBottom={flushBottom}
                isLight={isLight}
                isCreamHeavy={isCreamHeavy}
            />
        </CarouselProvider>
    );
};

FlipDeck.propTypes = {
    flushBottom: PropTypes.bool,
    flushTop: PropTypes.bool,
    isLight: PropTypes.bool,
    isCreamHeavy: PropTypes.bool,
    slides: PropTypes.array,
};

export default FlipDeck;
